export const en = {
    "title": "Event planner",
    "my-events": "My events",
    "more-info": "More info",
    "add-event-btn": "Add new event",
    "create-event": "Create new event",
    "create-event-title": "Title",
    "create-event-description": "Description",
    "create-event-date": "Select date",
    "create-event-time": "Select time",
    "create-event-location": "Location",
    "create-event-image": "Select image",
    "image-placeholder": "Select",
    "create-event-category": "Category",
    "create-event-priority": "Priority",
    "create-event-btn": "Add event",
    "go-back": "Back",
    "delete-event": "Delete event",
    "at": "at",
    "select-date": "Select date",
    "search-input": "Search by name",
    "not-selected": "Not selected",
}